<template>
  <div>
    <span :class="data.orderSalaryP>data.orderSalaryT ? 'blue' : ''">{{ data.orderSalaryP }}</span>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {

    }
  },
}
</script>

<style scoped>
.blue {
  color: blue;
}
</style>
